import wretch from 'wretch';
import * as v from 'valibot';
import { BrandingSchema, TBranding } from '../schemas/branding';
import { localizedErrorHandlers } from '../localizedErrorHandlers';

export const getBranding = async (
  baseUrl?: string,
  brandingId?: number,
): Promise<TBranding> => {
  if (!brandingId || !baseUrl) {
    throw new Error(
      'fe-core | getBrandingData | branding baseUrl or brandingId undefined',
    );
  }

  const url = `${baseUrl}/branding/package/${brandingId}`;
  const instance = wretch(url, { credentials: 'include' }).get();
  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(BrandingSchema, response);

    if (validatedResponse.success) {
      return validatedResponse.output;
    } else {
      console.error('fe-core | getBrandingData | ', validatedResponse.issues);
      throw new Error('Invalid branding response');
    }
  });
};
